<nav
  class="relative flex items-center h-[72px] w-full px-4 bg-white pt-8 pb-2 lg:px-20 justify-between"
>
  <svg
    (click)="showNavbar()"
    class="xl:hidden"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.6667 11.8334H29.3334"
      stroke="#141B34"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.6667 20H29.3334"
      stroke="#141B34"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.6667 28.1666H22.3334"
      stroke="#141B34"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>

  <div class="flex h-full items-center gap-12 text-neutral-20">
    <a routerLink="/" (click)="navBar = false">
      <svg
        width="131"
        height="20"
        viewBox="0 0 131 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.5538 7.70884C12.4889 6.4082 11.172 5.75787 9.60584 5.75787C8.91758 5.75787 8.27538 5.88252 7.67925 6.13452C7.09938 6.38652 6.59809 6.73065 6.17537 7.16962C5.75266 7.59233 5.41666 8.10175 5.16466 8.69788C4.92892 9.29401 4.8124 9.93621 4.8124 10.6245C4.8124 11.3127 4.92892 11.9793 5.16466 12.5754C5.41666 13.1716 5.75266 13.6864 6.17537 14.1254C6.61434 14.5644 7.12376 14.9085 7.70364 15.1605C8.28351 15.4125 8.90945 15.5371 9.58416 15.5371C11.0555 15.5371 12.3806 14.9112 13.5566 13.6566V19.1085L13.0878 19.2738C12.3833 19.5258 11.7248 19.7046 11.1151 19.813C10.5055 19.9377 9.90119 20 9.30506 20C8.08299 20 6.90699 19.7724 5.77976 19.3198C4.66879 18.8511 3.67975 18.2008 2.81807 17.3689C1.97265 16.5235 1.28981 15.529 0.77497 14.3855C0.25742 13.2258 0 11.9658 0 10.6028C0 9.23982 0.252003 7.99336 0.753294 6.86613C1.27084 5.72264 1.95097 4.74445 2.7964 3.92883C3.65808 3.09967 4.65253 2.45747 5.77976 2.00225C6.90699 1.53347 8.09112 1.29773 9.32945 1.29773C10.034 1.29773 10.7249 1.37631 11.3969 1.53347C12.0852 1.67438 12.806 1.90199 13.5593 2.2136V7.71155L13.5538 7.70884Z"
          fill="black"
        />
        <path
          d="M20.2631 13.4186C20.2631 13.825 20.3336 14.2017 20.4745 14.5458C20.6316 14.8737 20.8267 15.1636 21.0625 15.4156C21.3145 15.6676 21.6017 15.8627 21.9323 16.0036C22.2764 16.1445 22.6368 16.215 23.0134 16.215C23.3901 16.215 23.7424 16.1445 24.0702 16.0036C24.4144 15.8627 24.7043 15.6676 24.94 15.4156C25.192 15.1636 25.3871 14.8764 25.528 14.5458C25.6852 14.2017 25.7638 13.8332 25.7638 13.4403C25.7638 13.0474 25.6852 12.7114 25.528 12.3835C25.3871 12.0394 25.192 11.7413 24.94 11.4893C24.7043 11.2373 24.4144 11.0422 24.0702 10.9013C23.7424 10.7604 23.3901 10.6899 23.0134 10.6899C22.6368 10.6899 22.2764 10.7604 21.9323 10.9013C21.6044 11.0422 21.3145 11.2373 21.0625 11.4893C20.8267 11.7413 20.6316 12.0285 20.4745 12.3591C20.3336 12.687 20.2631 13.0392 20.2631 13.4159V13.4186ZM15.7759 13.3725C15.7759 12.4783 15.9547 11.6492 16.3151 10.8823C16.6755 10.0992 17.1768 9.42451 17.819 8.86089C18.4612 8.28102 19.2199 7.8258 20.0978 7.49792C20.992 7.17005 21.9621 7.00476 23.0107 7.00476C24.0594 7.00476 24.9996 7.17005 25.8776 7.49792C26.7718 7.81225 27.5386 8.25664 28.1808 8.83651C28.8393 9.40012 29.3487 10.083 29.7091 10.8796C30.0695 11.6627 30.2483 12.5325 30.2483 13.489C30.2483 14.4456 30.0613 15.3208 29.6847 16.1201C29.3243 16.9032 28.823 17.5861 28.1808 18.1632C27.5386 18.7269 26.7637 19.1658 25.8532 19.4802C24.959 19.7945 23.9889 19.9489 22.9403 19.9489C21.8916 19.9489 20.9514 19.7918 20.0734 19.4802C19.1955 19.1658 18.4368 18.7214 17.7946 18.1416C17.1687 17.5617 16.6755 16.8734 16.3151 16.0741C15.9547 15.2585 15.7759 14.3588 15.7759 13.3725Z"
          fill="black"
        />
        <path
          d="M35.5454 7.44897L38.4367 13.7951L41.4444 7.44897H44.1243L47.1321 13.982L50.1642 7.44897H54.8872L48.5899 19.5044H45.7474L42.7397 12.9009L39.8728 19.5044H36.9816L30.8008 7.44897H35.5482H35.5454Z"
          fill="black"
        />
        <path
          d="M59.9243 13.4186C59.9243 13.825 59.9947 14.2017 60.1356 14.5458C60.2928 14.8737 60.4879 15.1636 60.7236 15.4156C60.9756 15.6676 61.2628 15.8627 61.5934 16.0036C61.9375 16.1445 62.2979 16.215 62.6746 16.215C63.0512 16.215 63.4035 16.1445 63.7314 16.0036C64.0755 15.8627 64.3654 15.6676 64.6012 15.4156C64.8505 15.1636 65.0483 14.8764 65.1892 14.5458C65.3463 14.2017 65.4249 13.8332 65.4249 13.4403C65.4249 13.0474 65.3463 12.7114 65.1892 12.3835C65.0483 12.0394 64.8532 11.7413 64.6012 11.4893C64.3654 11.2373 64.0755 11.0422 63.7314 10.9013C63.4035 10.7604 63.0512 10.6899 62.6746 10.6899C62.2979 10.6899 61.9375 10.7604 61.5934 10.9013C61.2655 11.0422 60.9756 11.2373 60.7236 11.4893C60.4879 11.7413 60.2928 12.0285 60.1356 12.3591C59.9947 12.687 59.9243 13.0392 59.9243 13.4159V13.4186ZM55.437 13.3725C55.437 12.4783 55.6186 11.6492 55.9789 10.8823C56.3393 10.0992 56.8406 9.42451 57.4828 8.86089C58.125 8.28102 58.8837 7.8258 59.7617 7.49792C60.6559 7.17005 61.6259 7.00476 62.6746 7.00476C63.7232 7.00476 64.6635 7.17005 65.5414 7.49792C66.4356 7.81225 67.2025 8.25664 67.8447 8.83651C68.5031 9.40012 69.0125 10.083 69.3729 10.8796C69.7333 11.6627 69.9122 12.5325 69.9122 13.489C69.9122 14.4456 69.7252 15.3208 69.3485 16.1201C68.9882 16.9032 68.4869 17.5861 67.8447 18.1632C67.2025 18.7269 66.4275 19.1658 65.517 19.4802C64.6229 19.7945 63.6528 19.9489 62.6041 19.9489C61.5555 19.9489 60.6152 19.7918 59.7373 19.4802C58.8594 19.1658 58.1006 18.7214 57.4584 18.1416C56.8325 17.5617 56.3393 16.8734 55.9789 16.0741C55.6186 15.2585 55.437 14.3588 55.437 13.3725Z"
          fill="black"
        />
        <path
          d="M72.5381 7.44946H76.7923V9.42211C77.2475 8.70134 77.803 8.15398 78.4615 7.77733C79.1199 7.38443 79.8868 7.18933 80.7647 7.18933H81.117C81.2579 7.18933 81.415 7.20559 81.5857 7.2354V11.2999C81.0221 11.0181 80.4097 10.8772 79.754 10.8772C78.7677 10.8772 78.0225 11.1753 77.5212 11.7714C77.0362 12.3513 76.7923 13.2048 76.7923 14.3321V19.5021H72.5381V7.44675V7.44946Z"
          fill="black"
        />
        <path
          d="M87.9129 0V11.798L92.3785 7.45164H98.207L92.1671 13.02L98.5593 19.507H92.5898L87.9129 14.5944V19.507H83.6587V0H87.9129Z"
          fill="black"
        />
        <path
          d="M100.245 7.44946H104.499V9.42211C104.955 8.70134 105.51 8.15398 106.168 7.77733C106.827 7.38443 107.594 7.18933 108.472 7.18933H108.824C108.965 7.18933 109.122 7.20559 109.293 7.2354V11.2999C108.729 11.0181 108.117 10.8772 107.461 10.8772C106.475 10.8772 105.73 11.1753 105.228 11.7714C104.743 12.3513 104.499 13.2048 104.499 14.3321V19.5021H100.245V7.44675V7.44946Z"
          fill="black"
        />
        <path
          d="M117.663 15.9577H122.738V19.5074H110.517L116.205 11.0017H111.292V7.45203H123.301L117.663 15.9577Z"
          fill="black"
        />
        <path
          d="M125.263 17.2472C125.263 16.8705 125.334 16.5183 125.475 16.1904C125.615 15.8462 125.811 15.5482 126.063 15.2962C126.315 15.0442 126.602 14.8491 126.932 14.7082C127.276 14.5673 127.637 14.4968 128.014 14.4968C128.39 14.4968 128.742 14.5673 129.07 14.7082C129.414 14.8491 129.712 15.0442 129.964 15.2962C130.216 15.5482 130.412 15.8435 130.552 16.1904C130.693 16.5183 130.764 16.8705 130.764 17.2472C130.764 17.6238 130.693 17.9842 130.552 18.3283C130.412 18.6562 130.216 18.9461 129.964 19.1981C129.712 19.4501 129.417 19.6452 129.07 19.7861C128.742 19.927 128.39 19.9975 128.014 19.9975C127.637 19.9975 127.276 19.927 126.932 19.7861C126.604 19.6452 126.315 19.4501 126.063 19.1981C125.811 18.9461 125.615 18.6589 125.475 18.3283C125.334 17.9842 125.263 17.6238 125.263 17.2472Z"
          fill="black"
        />
      </svg>
    </a>
    <div
      #navBarTrigger
      class="h-full items-center gap-12 text-neutral-20 xl:flex xl:flex-row"
      [ngClass]="{
        'absolute flex-col left-0 top-[72px]': navBar,
        hidden: !navBar
      }"
    >
      @for (link of links; track $index) {
      <a
        [routerLink]="[link.link]"
        class="flex items-center font-light gap-2 cursor-pointer bg-white xl:[&.active]:bg-teal-seed xl:[&.active]:text-white xl:[&.active]:px-4 xl:[&.active]:py-2 xl:[&.active]:rounded-[28px] xl:flex"
        [ngClass]="{
          'h-[56px] w-screen p-4 lg:px-20 [&.active]:bg-teal-seed [&.active]:text-white border-teal-seed':
            navBar,
          hidden: !navBar
        }"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: false }"
      >
        <ng-icon [name]="link.icon" size="24px"> </ng-icon>
        <span>{{ link.label }}</span>
      </a>
      }
      <a
        href=""
        class="flex items-center font-light gap-2 cursor-pointer bg-white xl:hidden"
        [ngClass]="{
          'h-[56px] w-screen p-4 lg:px-20': navBar,
          hidden: !navBar
        }"
        routerLink="/start"
        (click)="signOut()"
      >
        <ng-icon name="hugeLogout01"></ng-icon>
        Log out
      </a>
    </div>
  </div>
  <div
    class="relative flex items-center justify-center gap-2"
    [uiMenuTriggerFor]="userMenu"
    yPosition="below"
    xPosition="before"
  >
    <button class="relative inline-block" (click)="displayCart()">
      <ng-icon name="hugeShoppingBasket03" size="28px"> </ng-icon>
      <ui-badge
        [color]="'red-light'"
        badgeText="{{ cart.totalItems > 99 ? '+99' : cart.totalItems }}"
        class="absolute top-[12px] left-[10px] flex items-center justify-center"
      ></ui-badge>
    </button>
    <div
      class="flex items-center justify-center rounded-full text-white h-8 w-8 bg-orange-seed cursor-pointer"
    >
      <button class="flex items-center space-x-4">
        {{
          user.profile.firstName.charAt(0).toUpperCase() +
            user.profile.lastName.charAt(0).toUpperCase()
        }}
      </button>
    </div>
  </div>
</nav>

<ui-menu #userMenu>
  <div class="py-2">
    <button
      (click)="signOut()"
      class="hover:bg-teal-seed hover:text-white shadow-sm transition-all duration-300 px-8 py-2 flex gap-2 items-center"
    >
      <ng-icon name="hugeLogout01"></ng-icon>
      Logout
    </button>
  </div>
</ui-menu>
